import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import axios from 'axios';

const Login = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // فرضی: POST به بک‌اند لاگین
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, values);
      console.log('Response:', res); // اضافه شد برای debug
      if (res.data && res.data.token) {
        localStorage.setItem('token', res.data.token);
        window.location.href = '/dashboard/home';
      } else {
        message.error('توکن دریافت نشد! پاسخ سرور را بررسی کنید.');
      }
    } catch (err) {
      message.error('Login Error:', err);
      if (err.response && err.response.data && err.response.data.message) {
        // نمایش پیام خطای سرور
        message.error(err.response.data.message);
      } else if (err.response) {
        message.error(`خطا: ${err.response.statusText}`);
      } else {
        message.error('خطای شبکه یا CORS');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}>
      <Card title="ورود به پنل ادمین" style={{ width: 350 }}>
        <Form layout="vertical" onFinish={onFinish}>
            <Form.Item name="email" label="ایمیل" rules={[{ required: true, message: 'لطفا ایمیل را وارد کنید' }]}>
                <Input type="email" />
            </Form.Item>
            <Form.Item name="password" label="رمز عبور" rules={[{ required: true, message: 'لطفا رمز عبور را وارد کنید' }]}>
                <Input.Password />
            </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              ورود
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
